import React, { useState } from 'react'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import { Box, Button, Grid, makeStyles, Typography } from '@material-ui/core'
import colors from '../../../../assets/colors'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'

import firstStep from '../../../../../public/img/client-coordinates-intructions/first-step.jpeg'
import secondStep from '../../../../../public/img/client-coordinates-intructions/second-step.jpeg'
import thirdStep from '../../../../../public/img/client-coordinates-intructions/third-step.png'

const useStyles = makeStyles({
  stepBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  stepInstructions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
  },
  stepTitle: {
    width: '100%',
    color: colors.textGray,
  },
  stepImage: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '440px',
    color: colors.textGray,
  },
  stepBtn: {},
  img: {
    borderRadius: '12px',
    width: '340px',
  },
})

export const HelperModal = ({ open = false, handleOpen }) => {
  const classes = useStyles()

  const [step, setStep] = useState(1)

  const handleReturn = () => {
    setStep(step - 1)
  }

  const handleAdvance = () => {
    setStep(step + 1)
  }

  return (
    <BaseFilterModal
      handleOpen={handleOpen}
      open={open}
      title={'Instruções'}
      hiddenHelpButton
    >
      <Grid
        item
        xs={12}
        style={{
          width: '380px',
          height: '480px'
        }}
      >
        <Grid container spacing={4}>
          {step == 1 && (
            <Grid item xs={12}>
              <Box className={classes.stepBox}>
                <Button
                  className={classes.stepBtn}
                  onClick={handleReturn}
                  disabled={step == 1}
                >
                  <Icon path={mdiChevronLeft} size={1} />
                </Button>

                <Box className={classes.stepInstructions}>
                  <Typography className={classes.stepTitle}>
                    1. Peça a localização atual do cliente.
                  </Typography>

                  <Box className={classes.stepImage}>
                    <img src={firstStep} alt="Teste" className={classes.img} />
                  </Box>
                </Box>

                <Button
                  className={classes.stepBtn}
                  onClick={handleAdvance}
                  disabled={step == 3}
                >
                  <Icon path={mdiChevronRight} size={1} />
                </Button>
              </Box>
            </Grid>
          )}

          {step == 2 && (
            <Grid item xs={12}>
              <Box className={classes.stepBox}>
                <Button
                  className={classes.stepBtn}
                  onClick={handleReturn}
                  disabled={step == 1}
                >
                  <Icon path={mdiChevronLeft} size={1} />
                </Button>

                <Box className={classes.stepInstructions}>
                  <Typography className={classes.stepTitle}>
                    2. Copie a localização.
                  </Typography>

                  <Box className={classes.stepImage}>
                    <img src={secondStep} alt="Teste" className={classes.img} />
                  </Box>
                </Box>

                <Button
                  className={classes.stepBtn}
                  onClick={handleAdvance}
                  disabled={step == 3}
                >
                  <Icon path={mdiChevronRight} size={1} />
                </Button>
              </Box>
            </Grid>
          )}

          {step == 3 && (
            <Grid item xs={12}>
              <Box className={classes.stepBox}>
                <Button
                  className={classes.stepBtn}
                  onClick={handleReturn}
                  disabled={step == 1}
                >
                  <Icon path={mdiChevronLeft} size={1} />
                </Button>

                <Box className={classes.stepInstructions}>
                  <Typography className={classes.stepTitle}>
                    3. Verifique se o link contém os seguintes campos
                  </Typography>

                  <Box className={classes.stepImage}>
                    <img src={thirdStep} alt="Teste" className={classes.img} />
                  </Box>
                </Box>

                <Button
                  className={classes.stepBtn}
                  onClick={handleAdvance}
                  disabled={step == 3}
                >
                  <Icon path={mdiChevronRight} size={1} />
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}
